import { Grid, Typography } from '@mui/material';
import { MaterialTransferido, OrdenTrabajo } from '@/shared/interfaces';
import { gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6 } from '@/shared';
import ModalUbProductoSelectTecnico from '@/erp/inventario/ingreso-producto/shared/componente/ModalUbProductoSelectTecnico';
import { toast } from 'react-toastify';
import { useTableColumnsInventarioSerie } from '@/shared/hooks/useTableColumnsInventarioSerie';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import SampleTablePagination from '@/shared/components/ui/SampleTablePagination';
import ModalProductoFactorTecnico from '@/shared/components/ui/CargarSeries/ModalProductoFactorTecnico';
import { useEffect } from 'react';

export type MaterialesUtilizadosInstallOTTecAsigProps = {
  ordenTrabajo?: OrdenTrabajo;
  form: any
  ubicacion?: string;
  onlyShow?:boolean;
  showToActivaciones?:boolean;
  enableNoOnt?:boolean;
  esVisita?:boolean;
};

const MaterialesUtilizadosInstallOTTecAsig: React.FC<
  MaterialesUtilizadosInstallOTTecAsigProps
> = ({ form, ubicacion, onlyShow = false,
  showToActivaciones = false, enableNoOnt = false, esVisita = false}) => {

  ///* global state -----------------------
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const productos = useCargarSeriesProductos(s => s.productos)
  const setProductos = useCargarSeriesProductos(s => s.setProductos)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const handleAgregarSeriesArrayProductos = useCargarSeriesProductos(s => s.handleAgregarSeriesArrayProductos)

  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)

  const { columnsMaterialesTecnicos } = useTableColumnsInventarioSerie()

  useEffect(() => {
    if(!onlyShow 
      && form?.getValues()?.materiales_utilizados 
      && form?.getValues()?.materiales_utilizados?.length > 0){
        setProductos(form?.getValues()?.materiales_utilizados)
        handleAgregarSeriesArrayProductos(form?.getValues()?.materiales_utilizados)
    }
  }, [])

  return (
    <>
      {/* <TabTextLabel text="EQUIPOS UTILIZADOS" pt="48px" /> */}

      <Grid item container spacing={4}>
        <Grid item container xs={12} alignSelf="flex-end">
          <Grid {...gridSizeMdLg12} container item>
            <Grid container item {...gridSizeMdLg6} alignItems={"center"}>
              <Typography variant="body1" fontWeight={700}>{esVisita ? 'Materiales de Visita' : 'Materiales de Instalación'}</Typography>
            </Grid>
            <Grid container item {...gridSizeMdLg6} alignItems={"center"} justifyContent={"end"}>
              {onlyShow?null:
              <ModalUbProductoSelectTecnico
                control={form.control}
                ubicacion={ubicacion!}
                onChange={(val)=>{
                  if (val.stock && +val.stock! <= 0)
                    return toast.error(`Producto con el código ${val.codigo} no tiene stock disponible.`);

                  if (enableNoOnt && val.es_ont)
                    return toast.error(`No se puede agregar mas de una ONT por instalación`);
                  const aux: MaterialTransferido = {
                    id: val.id_producto,
                    codigo: val.codigo,
                    cantidad: '1',
                    producto_data: {
                      codigo: val.codigo,
                      categoria_producto: val.categoria_producto,
                      descripcion: val.descripcion,
                      stock_actual: val.stock,
                      modelo_producto: val.modelo_producto,
                      marca_producto: val.marca_producto,
                      unidad_medida: val.unidad_medida,
                      presentacion: val.presentacion,
                      subcategoria_producto: val.subcategoria_producto,
                      subcategoria_producto_data: val.subcategoria_producto_data,
                      productos_asociados: val.productos_asociados ?? [],
                      es_ont: val.es_ont,
                      es_utp: val.es_utp,
                    },
                    metros_actuales: val.usa_metros ? val.metros_actuales : val.stock,
                    contiene_serie: val.contiene_serie,
                    series: [],
                    usa_metros: val.usa_metros,
                    ubicacion_origen: ubicacion,
                  }
                  handleAgregarProducto(aux)
                }}
              />}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <SampleTablePagination
            columns={columnsMaterialesTecnicos}
            data={showToActivaciones?
              (form?.getValues()?.materiales_utilizados as MaterialTransferido[] || []) 
              : paginatedData}
            rowCount={productos.length}
            setPagination={setPagination}
            pagination={pagination}
            rowNumber={true}
          />
        </Grid>


        {/* --------------- MODALS --------------- */}
        {/* ------ Modal Inventario Factor ------ */}
        <ModalProductoFactorTecnico
          generarSerie={false}
          seleccionarAutomatico={true}
          seleccionarManual={true}
          size={gridSizeMdLg4}
        />
      </Grid>
    </>
  );
};

export default MaterialesUtilizadosInstallOTTecAsig;
